<template>
<!-- eslint-disable max-len -->
<div
  v-if="!autoSubmit"
  class="reason"
  :style="{
    width: decision.decisionContainerWidthOverride ? decision.decisionContainerWidthOverride : undefined,
    'max-height': decision.decisionContainerMaxHeightOverride ? decision.decisionContainerMaxHeightOverride : undefined,
  }"
>
  <div
    v-if="!choiceOrFreeResponse && selectedChoices && !['form'].includes(decision.type)"
    class="choice btn-white"
    :style="{
      width: decision.decisionContainerWidthOverride ? `calc(${decision.decisionContainerWidthOverride} - 70px)` : undefined,
    }"
  >
    <h4 v-if="!['roleAllocation', 'projectAllocation'].includes(decision.type)">Selected Choices:</h4>
    <budgets-bar v-else style="width: 1100px; padding: 0px;" :totalBudget="totalBudget" :choices="choices" :colors="allocationColors" overrideBudgetTitle="Selected Allocation"></budgets-bar>
    <div style="overflow-y: auto; overflow-x: hidden;" :style="choicesContainerStyle">
      <h3 v-if="selectedChoices.length === 0">None</h3>
      <div v-if="['roleAllocation', 'projectAllocation'].includes(decision.type)">
        <div v-for="(choice, i) in selectedChoices"
          :key="`choice-${i}`"
          style="display: flex; justify-content: space-between;"
          >
          <div style="display: flex; justify-content: left; margin-bottom: 2px;">
            <div :style="`width: 32px; height: 32px; background-color: ${allocationColors[i]};`"/>
            <h4 style="margin-left: 8px;">{{getChoiceLabel(choice)}}</h4>
          </div>
          <h4 class="currency" style="margin-right: 8px;">{{formatCurrencyString(choice.allocation)}}</h4>
        </div>
      </div>
      <div v-else>
        <accordion
          v-for="(choice, i) in selectedChoices"
          :key="`choice-${i}`"
          :accordion-id="`choice-${i}`"
        >
          <template v-if="decision.type === 'sliders'">
            <div class="choice-header" slot="button" style="height: 50px;">
              <!--
                Never use v-html with end-user generated content, because it's a vector for XSS attacks
                This is what the following line used to be:
                <h3>{{ choice.title }}</h3>
              -->
              <h3 v-html="getChoiceDisplayTitle(choice)" style="margin: 0;"></h3>
              <span v-if="!(choice && choice.sliderHideValue)" class="choice-cost">
                Selected {{ choice.valueString }}
              </span>
            </div>
          </template>
          <template v-else-if="decision.type === 'matching'">
            <div
              class="choice-header"
              slot="button"
              style="
                height: fit-content;
                width: 100%;
                padding: 8px 4px;
                font-size: 26px;
                line-height: 1.13;
                font-weight: 500;
                display: flex;
                justify-content: space-between;
              "
            >
              <!--
                Never use v-html with end-user generated content, because it's a vector for XSS attacks
                This is what the following line used to be:
                <h3>{{ choice.title }}</h3>
              -->
              <div v-html="getChoiceDisplayTitle(choice)"></div>
              <div v-if="choice && choice.category && (choice.category.displayName || choice.category.name)">
                <span style="font-size: 80%;">Match:</span> <span v-html="(choice.category.displayName || '').replaceAll(/font-size:[^;]*;/g, '') || choice.category.name"></span>
              </div>
            </div>
          </template>
          <template v-else-if="decision.type === 'scale'">
            <div
              class="choice-header"
              slot="button"
              style="
                height: fit-content;
                width: 100%;
                padding: 8px 4px;
                font-size: 26px;
                line-height: 1.13;
                font-weight: 500;
                display: flex;
                justify-content: space-between;
              "
            >
              <div v-html="getChoiceDisplayTitle(choice)"></div>
              <div v-if="choice && choice.category && (choice.category.displayName || choice.category.name)">
                <span style="font-size: 80%;">Selected:</span> <span v-html="(choice.category.displayName || '').replaceAll(/font-size:[^;]*;/g, '') || choice.category.name"></span>
              </div>
            </div>
            <p
              v-if="choice && choice.description"
              v-html="getChoiceDisplayDescription(choice)"
              class="choice-description"
              slot="body"
              :style="choiceDescriptionStyle"
            ></p>
          </template>
          <template v-else-if="decision.type === 'matrix'">
            <div
              class="choice-header"
              slot="button"
              style="
                height: fit-content;
                width: 100%;
                padding: 8px 4px;
                font-size: 26px;
                line-height: 1.13;
                font-weight: 500;
                display: flex;
                justify-content: space-between;
              "
            >
              <div v-html="getChoiceDisplayTitle(choice)"></div>
              <div v-if="choice && choice.categories && choice.categories.length">
                <span style="font-size: 80%;">Selected:</span>
                <span
                  v-for="(category, c) in choice.categories"
                  :key="`catlist-${c}`"
                  v-if="category && (category.displayName || category.name)"
                  v-html="
                    `${
                      (category.displayName || '').replaceAll(/font-size:[^;]*;/g, '') || category.name
                    }${
                      (c < choice.categories.length - 1) ? '; ' : ''
                    }`
                  "
                ></span>
              </div>
            </div>
            <p
              v-if="choice && choice.description"
              v-html="getChoiceDisplayDescription(choice)"
              class="choice-description"
              slot="body"
              :style="choiceDescriptionStyle"
            ></p>
          </template>
          <div v-else-if="['roleAllocation', 'projectAllocation'].includes(decision.type)" class="choice-header" slot="button" style="height: 50px;">
            <h3 v-if="decision.type === 'roleAllocation'" style="margin: 0;">{{roles[choice.allocateToRole].title}}</h3>
            <h3 v-else style="margin: 0;">{{getChoiceDisplayTitle(choice)}}</h3>
            <span class="choice-cost">
              <span class="currency">{{ choice.allocation || 0 | currency }}</span>
            </span>
          </div>
          <template v-else>
            <div class="choice-header" slot="button" style="height: fit-content; min-height: 50px; max-width: 100%;">
              <!--
                Never use v-html with end-user generated content, because it's a vector for XSS attacks
                This is what the following line used to be:
                <h3>{{ choice.title }}</h3>
              -->
              <h3 v-html="getChoiceDisplayTitle(choice)" style="margin: 0; max-width: 100%; line-height: 123%; padding: 4px;"></h3>
              <span v-if="choice && !(choice.hideCost || forceHideCost) && !isNaN(parseFloat(choice.displayedCost || choice.cashAdjustment || 0))" class="choice-cost">
                COST <span class="currency">{{ -parseFloat((choice.displayedCost != undefined) ? choice.displayedCost : choice.cashAdjustment) || 0 | currency }}</span>
              </span>
            </div>
            <!--
              Never use v-html with end-user generated content, because it's a vector for XSS attacks,
              but this is okay here since choice.description is only used/set internally.
              If we decide we don't really need full html capability in descriptions, but still want proper new lines,
              replace the following line with:
              <p class="choice-description">{{choice.description}}</p>
            -->
            <p
              v-if="choice && choice.description"
              v-html="getChoiceDisplayDescription(choice)"
              class="choice-description"
              slot="body"
              :style="choiceDescriptionStyle"
            ></p>
          </template>
        </accordion>
      </div>
    </div>
  </div>
  <div
    v-else-if="choiceOrFreeResponse"
    class="choice btn-white"
    :style="{
      width: decision.decisionContainerWidthOverride ? `calc(${decision.decisionContainerWidthOverride} - 70px)` : undefined,
    }"
  >
    <div
      v-if="!(choiceImage(choiceOrFreeResponse)) || (choiceImage(choiceOrFreeResponse) && choiceOrFreeResponse.showTitle)"
      class="choice-header"
      :style="!(choiceOrFreeResponse.description) ? 'justify-content: center;' : ''"
    >
      <!--
        Never use v-html with end-user generated content, because it's a vector for XSS attacks
        This is what the following line used to be:
        <h2>{{ choice.title }}</h2>
      -->
      <h2 v-if="!isFreeResponse || !decision.hideTitle" v-html="choiceOrFreeResponseDisplayTitle"></h2>
      <p v-if="showCost && !(choiceOrFreeResponse.hideCost || forceHideCost) && !isNaN(parseFloat(choice.displayedCost || choice.cashAdjustment || 0))" class="choice-cost">
        COST <span class="currency">{{ -parseFloat((choice.displayedCost != undefined) ? choice.displayedCost : choice.cashAdjustment) || 0 | currency }}</span>
      </p>
    </div>
    <div style="display: flex; flex-flow: row; justify-content: center; flex-shrink: 0;">
      <img
        v-if="choiceImage(choiceOrFreeResponse)"
        :src="choiceImage(choiceOrFreeResponse)"
        style="max-width: 250px; max-height: 250px; object-fit: contain; margin-right: 15px;"/>
      <!--
        Never use v-html with end-user generated content, because it's a vector for XSS attacks,
        but this is okay here since choice.description is only used/set internally.
        If we decide we don't really need full html capability in descriptions, but still want proper new lines,
        replace the following line with:
        <p class="choice-description">{{choice.description}}</p>
      -->
      <p v-html="choiceOrFreeResponseDisplayDescription" class="choice-description" :style="choiceDescriptionStyle"></p>
    </div>
  </div>
  <budgets-bar v-else-if="choices.length > 0" class="budgets-bar" :choices="choices" :totalBudget="totalBudget" :colors="allocationColors" show-budget-used></budgets-bar>

  <form
    class="reason-form"
    :class="{
      'allocation-reason': ['roleAllocation', 'projectAllocation'].includes(decision.type) && choices.length > 0,
      'real-allocation-reason': ['roleAllocation', 'projectAllocation'].includes(decision.type),
    }"
    :style="{
      width: decision.decisionContainerWidthOverride ? `calc(${decision.decisionContainerWidthOverride} - 70px)` : undefined,
      'max-height': ['roleAllocation', 'projectAllocation'].includes(decision.type) ? '400px !important' : undefined,
    }"
  >
    <div v-if="showReasoningForm" class="form-group">
      <label for="reason">
        <div
          :style="{
            width: '100%',
            display: 'flex',
            'flex-direction': 'row',
            'justify-content': 'space-between',
            'align-items': 'flex-end',
            'font-size': (isFreeResponse ? '22px' : '32px'),
          }"
        >
          <div v-html="prompt">
          </div>
          <div v-if="reasoningRequired" style="font-size: 70%; text-align: right;">
            (At least {{reasoningMinimumLength}} characters required)
          </div>
        </div>
      </label>
      <textarea :style="`${['roleAllocation', 'projectAllocation'].includes(decision.type) ? 'max-height: 80px !important;' : ''}`" name="reason" id="reason" class="form-control" v-model="reason" v-focus :tabindex="1" :maxlength="reasoningMaximumLength"></textarea>
      <div class="character-counter">{{reason.length}} / {{reasoningMaximumLength}}</div>
    </div>

    <div class="buttons">
      <button v-if="!isFreeResponse" class="btn" id="back" @click.prevent="onClickBack(reason)" :tabindex="2">
        <span v-html="backButtonText === '' ? 'Back' : backButtonText"></span>
      </button>
      <button
        type="submit"
        class="btn"
        id="submit"
        @click.prevent="onClickApprove(reason)"
        :tabindex="3"
        :disabled="!reasonRequirementFulfilled || disableSubmit || waitingForIFrames"
      >
        <span v-html="submitButtonText === '' ? 'Approve' : submitButtonText"></span>
      </button>
    </div>
  </form>
  <tooltip
    target="reasonAndConfirmChoiceBubble"
  >
  </tooltip>
</div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import { incrementVersionCheckerProtectionCount, decrementVersionCheckerProtectionCount } from '../../../utils/version';

import BudgetsBar from './BudgetsBar';
import Accordion from '../../ui/display/Accordion';
import Tooltip from './Tooltip';
import { handleIFrames } from '../../../utils/utils';

export default {
  props: {
    decision: { type: [Object, Boolean] },
    choice: { type: Object },
    selectedChoices: { type: Array, default: () => [] },
    value: { type: String },
    choices: { type: Array, default: () => [] },
    totalBudget: { type: Number },
    allocationColors: { type: Array },
    showCost: { type: Boolean },
    disableReasoningForm: { type: Boolean, default: false },
    preventReasoningInputOverride: { type: Boolean, default: false },
    decisionReasoningMinimumLength: { type: Number, default: 0 },
    decisionReasoningMinimumLengthOverride: { type: Boolean, default: false },
    decisionReasoningMaximumLength: { type: Number, default: 0 },
    decisionReasoningMaximumLengthOverride: { type: Boolean, default: false },
    disableSubmit: { type: Boolean, default: false },
    submitButtonText: { type: String, default: 'Approve' },
    submitButtonSound: { type: String },
    backButtonText: { type: String, default: 'Back' },
  },
  components: {
    BudgetsBar,
    Accordion,
    Tooltip,
  },

  created() {
    if (this.autoSubmit) {
      this.$emit('input', this.reason);
    }
    if (this.showReasoningForm) {
      this.setDisableForcedLandscape(true);
    }
  },
  async mounted() {
    incrementVersionCheckerProtectionCount();
    await Vue.nextTick();
    this.stopSounds();
    if (!(this.autoSubmit) && (!(this.decision.type) || ['choice', 'survey', 'freeResponse'].includes(this.decision.type))) {
      if (this.isFreeResponse && this.decision.descriptionVoiceLine) {
        await Vue.nextTick();
        this.playVoice({ line: this.decision.descriptionVoiceLine, queue: false });
      } else if (!(this.isFreeResponse) && this.choice.descriptionVoiceLine) {
        await Vue.nextTick();
        this.playVoice({ line: this.choice.descriptionVoiceLine, queue: false });
      }
    }
    await Vue.nextTick();
    handleIFrames(this);
  },
  destroyed() {
    decrementVersionCheckerProtectionCount();

    this.setDisableForcedLandscape(false);
  },

  data() {
    return {
      framesToLoad: 0,
      reason: this.value,
    };
  },
  computed: {
    ...mapGetters([
      'activeEnvironment',
      'activeClass',
      'game',
      'selectedAvatar',
      'interpolateRegex',
      'replacements',
      'roles'
    ]),
    waitingForIFrames() {
      return !(this.noWaitForIFrames || this.decision.noWaitForIFrames) && this.framesToLoad > 0;
    },
    choiceDisplayType() {
      if (this.decision.type !== 'choice') {
        return 'list';
      }
      if (!(this.decision.preventChoiceDisplayTypeOverride)
        && this.activeClass && this.activeClass.choiceDisplayTypeOverride
        && this.activeClass.choiceDisplayTypeOverride !== 'Do Not Force') {
        switch (this.activeClass.choiceDisplayTypeOverride) {
          case 'List': return 'list';
          case 'Carousel': return 'carousel';
          default: return 'list';
        }
      }
      if (!(this.decision.choiceDisplayType)) return 'list';
      return this.decision.choiceDisplayType;
    },
    autoSubmit() {
      return !(this.isFreeResponse)
        && !(this.decision.forceConfirmation)
        && (this.decision.forceSkipConfirmation
          || (!(this.showReasoningForm) && this.noMoreInfoToDisplay));
    },
    noMoreInfoToDisplay() {
      // no description text or carousel where description text was already displayed
      // TODO: should this logic include choice image/video?
      return !(this.anyChoiceHasDescriptionText)
        || ((!(this.decision.type) || ['choice'].includes(this.decision.type))
          && ['carousel'].includes(this.choiceDisplayType));
    },
    anyChoiceHasDescriptionText() {
      return this.decision && this.decision.choices && this.decision.choices.some(c => c.description);
    },
    choiceHasDescriptionText() {
      return (this.choice && this.choice.description)
        || (this.choices && this.choices.some(c => c.description));
    },
    isFreeResponse() {
      return this.decision && this.decision.type && this.decision.type === 'freeResponse';
    },
    choiceOrFreeResponse() {
      if (this.choice == null && this.isFreeResponse) {
        return {
          title: this.decision.title,
          description: this.decision.description,
          image: this.decision.image,
          hideCost: true,
          showTitle: false,
        };
      }
      return this.choice;
    },
    choiceOrFreeResponseDisplayTitle() {
      if (this.choiceOrFreeResponse && this.choiceOrFreeResponse.displayNameForConfirmation) {
        return this.choiceOrFreeResponse.displayNameForConfirmation
          .replace(this.interpolateRegex, (__, tag) => this.replacements[tag] || '');
      } else if (this.choiceOrFreeResponse && this.choiceOrFreeResponse.title) {
        return this.choiceOrFreeResponse.title
          .replace(this.interpolateRegex, (__, tag) => this.replacements[tag] || '');
      }
      return '';
    },
    choiceOrFreeResponseDisplayDescription() {
      if (this.choiceOrFreeResponse && this.choiceOrFreeResponse.description) {
        return this.choiceOrFreeResponse.description
          .replace(this.interpolateRegex, (__, tag) => this.replacements[tag] || '');
      }
      return '';
    },
    choiceDisplayTitle() {
      if (this.choice && this.choice.displayNameForConfirmation) {
        return this.choice.displayNameForConfirmation
          .replace(this.interpolateRegex, (__, tag) => this.replacements[tag] || '');
      } else if (this.choice && this.choice.title) {
        return this.choice.title
          .replace(this.interpolateRegex, (__, tag) => this.replacements[tag] || '');
      }
      return '';
    },
    choiceDisplayDescription() {
      if (this.choice && this.choice.description) {
        return this.choice.description
          .replace(this.interpolateRegex, (__, tag) => this.replacements[tag] || '');
      }
      return '';
    },
    prompt() {
      return this.isFreeResponse
        ? ((this.decision && this.decision.prompt)
          ? this.decision.prompt
          : 'Enter your answer:')
        : 'Explain your reasoning...';
    },
    reasoningInputOverride() {
      if (this.isFreeResponse) return 'Force On';
      if (this.preventReasoningInputOverride) return 'Do Not Force';
      return (this.activeClass != null) ? this.activeClass.reasoningInputOverride :
        ((this.activeEnvironment != null && this.activeEnvironment.name != null)
          ? this.activeEnvironment.reasoningInputOverride : 'Do Not Force');
    },
    showReasoningForm() {
      if (this.reasoningInputOverride === 'Force On') {
        return true;
      } else if (this.reasoningInputOverride === 'Force Off') {
        return false;
      }
      return !(this.disableReasoningForm);
    },
    reasoningMaximumLength() {
      if (this.decisionReasoningMaximumLengthOverride) {
        return this.decisionReasoningMaximumLength || 0;
      }
      if (this.activeClass && this.activeClass.reasoningMaximumLength) {
        return this.activeClass.reasoningMaximumLength;
      }
      if (this.game && this.game.reasoningMaximumLength) {
        return this.game.reasoningMaximumLength;
      }
      if (this.decisionReasoningMaximumLength) {
        return this.decisionReasoningMaximumLength;
      }
      return 256;
    },
    reasoningMinimumLength() {
      if (this.decisionReasoningMinimumLengthOverride) {
        return this.decisionReasoningMinimumLength || 0;
      }
      if (this.activeClass && this.activeClass.reasoningMinimumLength) {
        return this.activeClass.reasoningMinimumLength;
      }
      if (this.game && this.game.reasoningMinimumLength) {
        return this.game.reasoningMinimumLength;
      }
      if (this.decisionReasoningMinimumLength) {
        return this.decisionReasoningMinimumLength;
      }
      if (this.isFreeResponse) {
        return 0; // change if free response should have a different default
      }
      return 0;
    },
    reasoningRequired() {
      return (this.showReasoningForm && this.reasoningMinimumLength !== 0);
    },
    reasonRequirementFulfilled() {
      return !(this.reasoningRequired && this.reason.length < this.reasoningMinimumLength);
    },
    forceHideCost() {
      return (this.decision != null && ['sliders', 'matching'].includes(this.decision.type));
    },
    choiceDescriptionStyle() {
      if (this.selectedChoices && this.selectedChoices.length) {
        return {
          'overflow-y': 'hidden',
          'max-height': '1800px'
        };
      }
      const { decisionContainerMaxHeightOverride } = this.decision;
      return {
        'max-height':
          ((this.showReasoningForm)
            ? undefined
            : (decisionContainerMaxHeightOverride
              ? `calc(460px + (${decisionContainerMaxHeightOverride} - 700px))`
              : '460px')),
      };
    },
    choicesContainerStyle() {
      return {
        'max-height':
          this.decision.decisionContainerMaxHeightOverride
            ? `calc(${
              (this.showReasoningForm) ? 0.4 : 0.66
            } * ${
              this.decision.decisionContainerMaxHeightOverride
            })`
            : ((this.showReasoningForm) ? '220px' : '460px'),
      };
    }
  },
  methods: {
    ...mapMutations([
      'setDisableForcedLandscape',
    ]),
    ...mapActions([
      'playSound',
      'playVoice',
      'stopSounds',
    ]),
    getChoiceLabel({ allocateToRole, title }) {
      switch (this.decision.type) {
        case 'projectAllocation':
          return title;
        case 'roleAllocation':
        {
          const role = this.roles[allocateToRole];
          return (role && role.title) || '???';
        }
        default: return title;
      }
    },
    async playBackClick() {
      await Vue.nextTick();
      this.playSound({
        sound:
          this.game.backButtonSound
          || this.game.clickSoundOverride
          || this.resolveAssetPath('click_cut.mp3', 'ui/customer'),
        soundIsUnstoppable: true,
      });
    },
    async playSubmitClick() {
      await Vue.nextTick();
      this.playSound({
        sound: this.submitButtonSound || this.game.clickSoundOverride || this.resolveAssetPath('click_cut.mp3', 'ui/customer'),
        soundIsUnstoppable: true,
      });
    },
    async onClickBack(reason) {
      await this.playBackClick();
      await new Promise(resolve => setTimeout(resolve, 250));
      this.$emit('back', reason);
    },
    async onClickApprove(reason) {
      await this.playSubmitClick();
      await new Promise(resolve => setTimeout(resolve, 250));
      this.$emit('input', reason);
    },
    getChoiceDisplayTitle(choice) {
      if (choice && choice.displayNameForConfirmation) {
        return choice.displayNameForConfirmation
          .replace(this.interpolateRegex, (__, tag) => this.replacements[tag] || '');
      } else if (choice && choice.title) {
        return choice.title
          .replace(this.interpolateRegex, (__, tag) => this.replacements[tag] || '');
      }
      return '';
    },
    getChoiceDisplayDescription(choice) {
      if (choice && choice.description) {
        return choice.description
          .replace(this.interpolateRegex, (__, tag) => this.replacements[tag] || '');
      }
      return '';
    },
    choiceImage(choice) {
      if (choice.playerVariantImage) {
        const variant =
          this.selectedAvatar.imageVariants.find(v => v.name === choice.playerVariantImage);
        if (variant) {
          return this.resolveAssetPath(variant.image, 'characters');
        }
      }

      if (choice.image) {
        return this.resolveAssetPath(choice.image, 'images');
      }

      return null;
    }
  }
};
</script>

<style lang="scss" scoped>
.reason {
  position: absolute;
  width: 1225px;
  min-height: 275px;
  max-height: 700px;
  background-color: white;
  padding: 15px 35px;
  display: flex;
  flex-flow: column;
  border-radius: 2px;
}
.choice {
  width: 1155px;
  position: relative;
  padding: 10px 25px;
  // reason-form has height of its content; choice fills the height available above
  min-height: 0%;
  display: flex;
  flex-shrink: 0;
  flex-flow: column;
}
.choice-header {
  height: 70px;
  display: flex;
  flex-flow: row;
  align-items: center;
  flex-shrink: 0;
}
.choice h2 {
  font-size: 39px;
  // font-weight: bold;
  margin: 0;
}
.choice-description {
  font-size: 24px;
  line-height: 40px;
  overflow-y: auto;
  margin-bottom: 5px;
  text-align: left;
  white-space: pre-line;
  max-height: 220px;
}
.choice-cost {
  position: absolute;
  right: 20px;
  margin: 0;
  font-size: 20px;
}
.choice-cost span {
  font-size: 32px;
  // font-weight: bold;
}
.reason-form {
  background-color: white;
  width: 1155px;
  position: relative;
  // reason-form has height of its content; choice fills the height available above
  flex: 0 0 content;
  display: flex;
  flex-shrink: 0;
  flex-flow: column;
}
.reason-form .form-group {
  flex: 1 1 auto;
  display: flex;
  flex-shrink: 0;
  flex-flow: column;
}
.reason-form .buttons {
  flex: 0 1 70px;
  padding: 0px;
  margin-top: auto;
}
.reason-form label {
  font-size: 32px;
  // font-weight: bold;
  margin-left: 10px;
  margin-bottom: 5px;
  flex: 0 1 auto;
}
.reason-form textarea {
  font-size: 24px;
  line-height: 35px;
  min-height: 185px;
  flex: 1 1 auto;
}
.reason-form textarea:focus {
  border: 4px solid var(--primaryColor);
}
.character-counter {
  font-size: 85%;
  color: rgb(150, 150, 150);
  flex: 0 1 auto;
}
.reason-form button {
  width: 250px;
  height: 80px;
  font-size: 30px;
}
.reason-form.allocation-reason {
  max-height: 455px;
}
.reason-form.allocation-reason textarea {
  height: 255px;
}
.budgets-bar {
  margin: 10px -3px 5px;
}
#back {
  float: left;
}
#submit {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/Reason.vue